<template>
  <div>
    <div class="row mr-1">
      <div class="col-12" align="right">
        <a
          :href="$store.state.api + 'download/import-model-vehicle'"
          target="_blank"
          class="btn btn-add"
          >Modelo de Importação</a
        >
        <button class="btn btn-add" @click="openInput">
          Importar Veiculos
        </button>
        <input
          name="fileImport"
          id="fileImport"
          type="file"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          style="display: none"
          value="null"
          @change="importFile"
        />
      </div>
    </div>
    <base-crud
      :ref="'vehiclesCrud'"
      crudName="Cadastro de Veículos"
      newText="Novo Veículo"
      :table="table"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="true"
      :enableDelete="true"
      :enableView="true"
      :dataForm="dataForm"
      :extra="extra"
      @bloquear="bloquear"
    ></base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "vehiclesTable",
      pages: [],
      url: "",
      columns: [
        "id",
        "photo",
        "description",
        // "brand",
        "board",
        "model_year",
        "combustible",
        "branch_id",
        "vehicle_status_id",
        "current_km",
        "actions",
      ],
      tableData: [
        "id",
        "photo",
        "description",
        // "brand",
        "board",
        "model_year",
        "combustible",
        "branch_id",
        "current_km",
        "vehicle_status_id",
      ],
      options: {
        sortable: [
          "id",
          "photo",
          "description",
          "board",
          "model_year",
          "combustible",
          "branch_id",
          "vehicle_status_id",
          "current_km",
        ],
        filterByColumn: true,
        debounce: 1000,
        filterable: [
          "id",
          "description",
          //   "brand",
          "board",
          "model_year",
          "combustible",
          "branch_id",
          "vehicle_status_id",
          "current_km",
        ],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          photo: "Foto do Veiculo",
          description: "Descrição",
          //   brand: "Marca",
          board: "Placa",
          model_year: "Ano",
          combustible: "Combustível",
          branch_id: "Filial",
          vehicle_status_id: "Status",
          current_km: "Km Atual",
          actions: "Ações",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione o Status",
        },
        listColumns: {
          vehicle_status_id: [
            {
              id: "2",
              text: "INDISPONÍVEL",
            },
            {
              id: "1",
              text: "DISPONÍVEL",
            },
          ],
        },
        templates: {
          vehicle_status_id: function (h, row, index) {
            return row.vehicle_status
              ? row.vehicle_status.description
              : "Sem Status";
          },
          branch_id: function (h, row, index) {
            return row.branch ? row.branch.description : "Sem Status";
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["vehicle_status", "branch"];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      extra: [
        {
          id: 1,
          label: "",
          class: "btn btn-crud block fas fa-ban",
          title: "Bloqueio / Desbloqueio",
          name: "bloquear",
          icon: "fas fa-ban",
        },
      ],
      endPoint: "vehicles/",
      dataForm: {},
    };
  },
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let fileImport = document.getElementById("fileImport");

      fd.append("fileImport", fileImport.files[0] ? fileImport.files[0] : "");

      return fd;
    },
    importFile() {
      const self = this;
      let api = self.$store.state.api + "import-vehicles";

      let fd = self.makeFormData();

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          self.showMessageImport = true;
          self.$refs.vehiclesCrud.$refs.table.refresh();
        })
        .catch((error) => {
          self.$message(
            "Ops",
            "Houve um erro durante a importação da planilha, verifique a planilha e tente novamente.",
            "error"
          );
        });
    },
    openInput() {
      document.getElementById("fileImport").click();
    },
    query: function (query) {
      let columns = {
        id: "id",
        description: "description",
        // brand: "brand",
        board: "board",
        model_year: "model_year",
        combustible: "combustible",
        branch_id: "branch[description]",
        current_km: "current_km",
        vehicle_status_id: "vehicle_status_id",
      };
      let filters = "orderByDesc=id&";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
    bloquear: function (props, row, index) {
      const self = this;
      self.save(props);
    },
    save(props) {
      const self = this;

      let api = self.$store.state.api + "vehicles/" + props.row.id;
      let fd = new FormData();

      fd.append("_method", "PATCH");

      let status =
        props.row.vehicle_status_id == 1
          ? (props.row.vehicle_status_id = 2)
          : (props.row.vehicle_status_id = 1);
      let board = props.row.board;

      fd.append("board", board);
      fd.append("vehicle_status_id", status);

      self.$http
        .post(api, fd)
        .then((response) => {
          props.row.vehicle_status_id = status;
          if (status == 1) {
            self.$message("Sucesso", `Veículo Desbloqueado`, "success");
            props.row.vehicle_status.description = "DISPONÍVEL";
          } else {
            self.$message("Sucesso", `Veículo Bloqueado`, "success");
            props.row.vehicle_status.description = "INDISPONÍVEL";
          }
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  components: {
    BaseCrud,
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Vehicle/Crud.vue